import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import MuiTabs from "../../../components/mui/tabs";
import AmbassadorsInfo from "./info";
import AmbassadorMeetings from "./meetings";
import AmbassadorPayments from "./payments";
import AmbassadorMeetingRecordings from "./meeting-recordings";
import AmbassadorInitiatives from "./initiatives";
import ambassadorHOC from "../ambassador-hoc";
import { useDispatch } from "react-redux";
import {
  resetSelectedAmbassador,
  resetAmbassadorInfo,
} from "../../../redux/modules/ambassadors/actions";
import { convertToFullName, convertToUrl } from "../../../services/utils";
import { ROUTE_PATHS } from "../../../routes/route-paths";

function AmbassadorDetails({
  ambassadorDetails,
  getAmbassadorDetails,
  setBreadcrumbLabelCustomText,
  history,
}) {
  const { id, tab }: any = useParams();
  const [selectedTab, setSelectedTab] = useState(tab);
  const dispatch = useDispatch();

  useEffect(() => {
    getAmbassadorDetails(id);

    return () => {
      dispatch(resetSelectedAmbassador());
      dispatch(resetAmbassadorInfo());
    };
  }, [id]);

  useEffect(() => {
    setSelectedTab(tab);
  }, [tab]);

  useEffect(() => {
    setBreadcrumbLabelCustomText(
      convertToFullName(
        ambassadorDetails?.firstName,
        ambassadorDetails?.lastName
      )
    );
  }, [ambassadorDetails]);

  const renderTabItems = () => {
    switch (selectedTab) {
      case "info":
        return <AmbassadorsInfo />;
      case "meetings":
        return <AmbassadorMeetings />;
      case "payments":
        return <AmbassadorPayments />;
      case "meeting_recordings":
        return <AmbassadorMeetingRecordings />;
      case "initiatives":
        return <AmbassadorInitiatives key={id} />;
      default:
        break;
    }
  };

  const handleTabChange = (value) => {
    setSelectedTab(value);

    const url = convertToUrl(ROUTE_PATHS.AMBASSADORS.DETAILS, {
      ":id": id,
      ":tab": value,
    });

    history.push(url);
  };

  if (!ambassadorDetails) return null;

  return (
    <Box display={"flex"} flexDirection="column">
      <MuiTabs
        items={[
          { value: "info", label: "Info" },
          { value: "meetings", label: "Meetings" },
          { value: "payments", label: "Payments" },
          { value: "meeting_recordings", label: "Meeting Recordings" },
          { value: "initiatives", label: "Initiatives" },
        ]}
        selectedTab={selectedTab}
        onTabChange={handleTabChange}
      />
      <Box mt={4}>{renderTabItems()}</Box>
    </Box>
  );
}

export default ambassadorHOC(AmbassadorDetails);
